module.exports = "mat-tab, {\r\n  min-width: 140px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/progress/progress.component.css
// module id = ./src/app/components/progress/progress.component.css
// module chunks = main